const DISALLOWED_FILENAME_CHARS_REGEX = /[\\/:"*?<>|#%]/;

export const getDisallowedFilenameCharsMessage = () =>
  'Please rename the file and upload again without these characters: \\ / : * ? " < > | # %';

export const hasDisallowedFilenameChars = (fileName = '') =>
  DISALLOWED_FILENAME_CHARS_REGEX.test(String(fileName || ''));
